<template>
  <div id="index-c" ref="indexC" :class="[isApp?'':'top']" :style="{top:topPosition+'px'}">
    <div class="index-c-root flex-row">
      <div class="fpl-15 flex-row ct" v-bind:class="[indexComplexIndex === 0 ? 'select-color' : 'unselect-color']"
        v-on:click="popClick(0)">综合</div>
      <!--<div class="index-c-line fpl-12 flex-row ct" v-on:click="popClick(1)">
        <span v-bind:class="[indexComplexIndex === 1 ? 'select-color' : 'unselect-color']">品牌</span>
        <img v-if="indexComplexIndex === 1" src="../images/ic_index_up.png">
        <img v-else src="../images/ic_index_down.png">
      </div>-->
      <div class="index-c-line"></div>
      <div class="fpl-12 flex-row ct" v-on:click="popClick(2)">
        <span v-bind:class="[indexComplexIndex === 2 ? 'select-color' : 'unselect-color']">价格</span>
        <img class="jt-img" v-if="indexComplexIndex === 2" src="../images/ic_index_up.png">
        <img class="jt-img" v-else src="../images/ic_index_down.png">
      </div>
      <div class="index-c-line"></div>
      <div class="fpl-12 flex-row ct" v-on:click="popClick(3)">
        <span v-bind:class="[indexComplexIndex === 3 ? 'select-color' : 'unselect-color']">所在地</span>
        <img class="jt-img" v-if="indexComplexIndex === 3" src="../images/ic_index_up.png">
        <img class="jt-img" v-else src="../images/ic_index_down.png">
      </div>
      <div class="index-c-line"></div>
      <div class="flex"></div>
    </div>
    <!-- <index-complex-pop v-show="popShow" v-bind:style="{top: ((isApp?0:-61)+50 + 91 + scrollY) + 'px'}" -->
    <!-- <index-complex-pop v-show="popShow" v-bind:style="{top:!startScroll?'unset':scrollHeight+'px'}" -->
    <index-complex-pop v-show="popShow" v-bind:style="{top:scrollHeight+'px'}"
      @onIndexCPopClick="onIndexCPopClick" :pop-type="popType" :price-select-index="popPriceIndex"
      :address-select-index="popAddressInex" />
  </div>
</template>

<script>
import IndexComplexPop from './index-complex-pop'
export default {
  name: 'index-complex',
  components: { IndexComplexPop },
  props: {
    icPopShow: false,
    icScrollY: 0,
    isApp: false,
    position: false,
    toTop: 0
  },
  data () {
    return {
      indexComplexIndex: 0, // 0：表示综合；1:表示品牌；2:表示价格；3:表示地区
      popShow: false,
      scrollY: 0, // 10表示阴影的高度
      popType: 0, // 0表示价格；1表示地区
      popPriceIndex: 0,
      popAddressInex: 0,
      startScroll: false,
      scrollHeight: 0,
      topPosition: 0
    }
  },
  methods: {
    popClick: function (index) {
      switch (index) {
        case 0: { // 综合
          if (this.popShow) {
            // this.popShow = false
            this.telFatherChnagePopShowValue(false)
          }
          this.indexComplexIndex = index
          this.selectData(this.indexComplexIndex, '1')
          break
        }
        case 1: { // 品牌
          if (this.popShow) {
            // this.popShow = false
            this.telFatherChnagePopShowValue(false)
          } else {
            this.indexComplexIndex = index
            this.showBrandPop()
          }
          break
        }
        case 2: { // 价格
          if (this.popShow) {
            // this.popShow = false
            this.telFatherChnagePopShowValue(false)
          } else {
            this.indexComplexIndex = index
            this.showPricePop()
          }
          break
        }
        case 3: { // 地区
          if (this.popShow) {
            // this.popShow = false
            this.telFatherChnagePopShowValue(false)
          } else {
            this.indexComplexIndex = index
            this.showAddressPop()
          }
          break
        }
      }
    },
    showBrandPop: function () { // 品牌
    },
    showPricePop: function () { // 价格
      this.popType = 0
      // this.popShow = true
      this.telFatherChnagePopShowValue(true)
    },
    showAddressPop: function () { // 所在地
      this.popType = 1
      // this.popShow = true
      this.telFatherChnagePopShowValue(true)
    },
    selectData: function (index, value) {
      this.$emit('indexCPopSelect', index, value)
    },
    onIndexCPopClick: function (popType, index, selectValue) {
      // this.popShow = false
      this.telFatherChnagePopShowValue(false)
      if (index === -1) {
        return
      }
      switch (popType) {
        case 0:
          this.popPriceIndex = index
          this.selectData(this.indexComplexIndex, selectValue)
          break
        case 1:
          this.popAddressInex = index
          this.selectData(this.indexComplexIndex, selectValue)
          break
      }
    },
    telFatherChnagePopShowValue: function (isPopShow) { // 通知父组件将状态改变
      this.$emit('indexCPopEmit', isPopShow)
    }
  },
  mounted () {
    this.topPosition = this.toTop
  },
  activated () {
    this.topPosition = this.toTop
  },
  watch: {
    icPopShow: function (newVal) {
      this.popShow = newVal
    },
    icScrollY: function (newVal) {
      this.topPosition = this.toTop
      this.scrollHeight = this.toTop + 34

      this.startScroll = newVal > 0
      if (newVal >= 10) { // 10表示阴影的高度
        this.scrollY = 0
      } else {
        this.scrollY = 10 - newVal
      }
      var cDom = document.getElementById('index-c')
      if (cDom === null) {

      }
      // console.log(cDom)
      // cDom.style.position = 'fixed'
      // document.getElementById('index-c').style.position = 'fixed'
    },
    toTop: function (newVal) {
      this.topPosition = this.toTop
      this.scrollHeight = this.toTop + 34
    },

    position: function (newVal) {
      // if (!this.isApp) {
      //   if (newVal === false) {
      //     this.topPosition = 168
      //   } else {
      //     this.topPosition = 285
      //   }
      // } else {
      //   if (newVal === false) {
      //     this.topPosition = 210
      //   } else {
      //     this.topPosition = 320
      //   }
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  touch-action: pan-y;
}
#index-c {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 104px;
  z-index: 3;
  &.top {
    position: fixed;
    top: unset;
  }
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.ct {
  align-items: center;
  justify-content: center;
}
.flex {
  flex: 1;
}
.index-c-root {
  background: white;
  height: 35px;
  width: 100%;
  border-top-width: 1px;
  border-top-color: #f2f2f2;
  border-top-style: solid;
  /*border-bottom-width: 1px;
    border-bottom-color: #f2f2f2;
    border-bottom-style: solid;*/
  box-shadow: 0 1px 1px 0 rgba(84, 83, 83, 0.11);
}
.index-c-line {
  /*border-right-color: #f2f2f2;
    border-right-style: solid;
    border-right-width: 1px;*/
  height: 34px;
  width: 1px;
  background: #f2f2f2;
}
.select-color {
  color: #c41335;
}
.unselect-color {
  color: #808080;
}
.jt-img {
  width: 8px;
  height: 5px;
  margin-left: 8px;
}
.fpl-12 {
  padding-left: 12px;
  padding-right: 12px;
}
.fpl-15 {
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/index-complex.vue